import { createFileRoute } from '@tanstack/react-router';
import { getAuditLogsTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/connected-products/audit')({
  beforeLoad: () => getAuditLogsTitleContextSlice(),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
